import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./About.css";

class About extends Component {
  render() {
    const services = [
      { title: "Hotel Booking", icon: "bi-building" },
      { title: "Resort Booking", icon: "bi-house-heart" },
      { title: "Apartment & Vacation Rental Booking", icon: "bi-house-door" },
      { title: "Short-Stay Accommodation", icon: "bi-calendar2-check" },
      { title: "Couple-Friendly Accommodation", icon: "bi-heart" },
      { title: "Family-Friendly Accommodation", icon: "bi-people" },
      { title: "Tour Packages", icon: "bi-map" },
      { title: "Travel Experiences & Activities", icon: "bi-compass" },
      { title: "Corporate Travel Solutions", icon: "bi-briefcase" },
      { title: "Car Rental Services", icon: "bi-car-front" },
      { title: "Event & Hospitality Services", icon: "bi-calendar-event" },
    ];

    const missionPoints = [
      "To simplify travel planning and accommodation booking.",
      "To empower travelers with trusted choices and transparent information.",
      "To support hotels, resorts, apartment owners, tour operators, and local tourism businesses through digital transformation.",
      "To promote tourism and hospitality growth across Bangladesh and international destinations.",
    ];

    const reasons = [
      {
        title: "Trusted Partners",
        description:
          "We work with accommodation providers, tour operators, and service partners committed to delivering quality experiences.",
        icon: "bi-patch-check",
      },
      {
        title: "Easy Booking Experience",
        description:
          "Our platform is designed to make searching, comparing, and booking simple and convenient.",
        icon: "bi-search-heart",
      },
      {
        title: "Diverse Travel Options",
        description:
          "From budget-friendly stays to premium accommodations, Bookly offers options for every traveler.",
        icon: "bi-grid",
      },
      {
        title: "Customer-Focused Service",
        description:
          "We are committed to providing responsive support and a smooth travel experience from booking to check-out.",
        icon: "bi-headset",
      },
    ];

    return (
      <div className="about-us-page">
        {/* Hero */}
        <section className="about-hero position-relative">
          <div className="hero-overlay"></div>

          <div className="container position-relative z-2">
            <div className="row justify-content-center">
              <div className="col-xl-9 text-center text-white">
                <span className="about-eyebrow animate-fade-up">
                  BOOKLY LIMITED
                </span>

                <h1 className="about-hero-title animate-fade-up">
                  Explore More. Stay Better.
                  <br />
                  Travel Smarter.
                </h1>

                <p className="about-hero-text animate-fade-up delay-1">
                  Your trusted partner for travel, tourism, and hospitality
                  solutions.
                </p>

                <div className="hero-pills animate-fade-up delay-2">
                  <span>
                    <i className="bi bi-buildings me-2"></i>
                    Trusted Accommodation
                  </span>
                  <span>
                    <i className="bi bi-compass me-2"></i>
                    Travel Experiences
                  </span>
                  <span>
                    <i className="bi bi-headset me-2"></i>
                    Customer-Focused Service
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-bottom-fade"></div>
        </section>

        {/* Welcome */}
        <section className="about-section about-welcome-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <div className="section-kicker">
                  <span></span>
                  ABOUT BOOKLY
                </div>

                <h2 className="section-title">
                  Welcome to <span>Bookly Limited</span>
                </h2>

                <p className="section-lead">
                  At Bookly Limited, we believe that travel should be simple,
                  accessible, and memorable.
                </p>

                <p className="section-text">
                  Our mission is to connect travelers with trusted
                  accommodations, unique experiences, and reliable travel
                  services through one convenient platform.
                </p>

                <p className="section-text">
                  Founded with a vision to transform the travel and
                  hospitality industry in Bangladesh and beyond, Bookly serves
                  as a bridge between travelers and service providers, making
                  it easier to discover, compare, and book travel-related
                  services with confidence.
                </p>

                <p className="section-text mb-0">
                  Whether you are planning a business trip, a family vacation,
                  a weekend getaway, or a special event, Bookly helps you find
                  the right place to stay and the right experiences to enjoy.
                </p>
              </div>

              <div className="col-lg-6">
                <div className="welcome-visual">
                  <div className="welcome-main-card">
                    <img
                      src="https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1000&q=85"
                      alt="Bookly accommodation"
                    />

                    <div className="welcome-floating-card">
                      <div className="floating-icon">
                        <i className="bi bi-stars"></i>
                      </div>
                      <div>
                        <strong>Better Travel</strong>
                        <small>Simple. Trusted. Convenient.</small>
                      </div>
                    </div>
                  </div>

                  <div className="welcome-accent-card">
                    <i className="bi bi-globe2"></i>
                    <strong>Bangladesh & Beyond</strong>
                    <span>Connecting travelers and service providers</span>
                  </div>

                  <div className="welcome-dot-pattern"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What We Do */}
        <section className="about-section bg-light-gray">
          <div className="container">
            <div className="text-center section-heading">
              <div className="section-kicker justify-content-center">
                <span></span>
                WHAT WE DO
                <span></span>
              </div>

              <h2 className="section-title">
                Travel & Hospitality <span>Solutions</span>
              </h2>

              <p className="section-subtitle mx-auto">
                Bookly offers a wide range of travel and hospitality solutions
                designed to make planning and booking easier.
              </p>
            </div>

            <div className="row g-4">
              {services.map((service, index) => (
                <div className="col-sm-6 col-lg-4 col-xl-3" key={index}>
                  <div className="service-card h-100 hover-lift">
                    <div className="service-icon">
                      <i className={`bi ${service.icon}`}></i>
                    </div>

                    <h5>{service.title}</h5>

                    <div className="service-arrow">
                      <i className="bi bi-arrow-up-right"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="service-note mt-5">
              <i className="bi bi-check2-circle"></i>
              <span>
                Our goal is to create a seamless booking experience while
                supporting local tourism businesses and hospitality providers.
              </span>
            </div>
          </div>
        </section>

        {/* Vision & Mission */}
        <section className="about-section">
          <div className="container">
            <div className="row g-4">
              <div className="col-lg-5">
                <div className="vision-card h-100">
                  <div className="card-icon">
                    <i className="bi bi-eye"></i>
                  </div>

                  <span className="card-label">OUR VISION</span>

                  <h3>
                    Building a more
                    <span> connected travel future.</span>
                  </h3>

                  <p>
                    To become the most trusted and innovative travel, tourism,
                    and hospitality platform in Bangladesh, connecting people
                    with exceptional travel experiences and quality
                    accommodations.
                  </p>

                  <div className="card-decoration">
                    <i className="bi bi-globe-americas"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-7">
                <div className="mission-card h-100">
                  <div className="card-icon">
                    <i className="bi bi-bullseye"></i>
                  </div>

                  <span className="card-label">OUR MISSION</span>

                  <h3>
                    Making travel
                    <span> simpler, smarter, and more accessible.</span>
                  </h3>

                  <div className="mission-list">
                    {missionPoints.map((point, index) => (
                      <div className="mission-item" key={index}>
                        <div className="mission-check">
                          <i className="bi bi-check-lg"></i>
                        </div>

                        <p>{point}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Bookly */}
        <section className="about-section bg-light-gray">
          <div className="container">
            <div className="text-center section-heading">
              <div className="section-kicker justify-content-center">
                <span></span>
                WHY CHOOSE BOOKLY
                <span></span>
              </div>

              <h2 className="section-title">
                Built Around <span>Your Journey</span>
              </h2>

              <p className="section-subtitle mx-auto">
                We focus on trust, convenience, choice, and responsive
                service throughout your travel experience.
              </p>
            </div>

            <div className="row g-4">
              {reasons.map((reason, index) => (
                <div className="col-md-6 col-xl-3" key={index}>
                  <div className="reason-card h-100 hover-lift">
                    <div className="reason-number">0{index + 1}</div>

                    <div className="reason-icon">
                      <i className={`bi ${reason.icon}`}></i>
                    </div>

                    <h4>{reason.title}</h4>

                    <p>{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Commitment */}
        <section className="commitment-section">
          <div className="container">
            <div className="commitment-box">
              <div className="commitment-content">
                <div className="section-kicker text-white">
                  <span></span>
                  OUR COMMITMENT
                </div>

                <h2>
                  Helping people explore, discover, and create meaningful
                  journeys.
                </h2>

                <p>
                  At Bookly, we are passionate about helping people explore new
                  destinations, discover memorable experiences, and create
                  meaningful journeys.
                </p>

                <p className="mb-0">
                  We continuously strive to improve our platform, expand our
                  services, and build a trusted travel ecosystem that benefits
                  travelers, partners, and local communities alike.
                </p>
              </div>

              <div className="commitment-visual">
                <div className="commitment-circle">
                  <i className="bi bi-airplane-engines"></i>
                </div>
                <div className="commitment-circle small-circle">
                  <i className="bi bi-heart"></i>
                </div>
                <div className="commitment-circle tiny-circle">
                  <i className="bi bi-geo-alt"></i>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="about-section contact-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-7">
                <div className="section-kicker">
                  <span></span>
                  CONTACT US
                </div>

                <h2 className="section-title mb-3">
                  Let’s plan your next <span>journey.</span>
                </h2>

                <p className="section-text mb-0">
                  Have questions about Bookly or our travel and hospitality
                  solutions? Get in touch with our team.
                </p>
              </div>

              <div className="col-lg-5">
                <div className="contact-card">
                  <div className="contact-brand">
                    <div className="contact-brand-icon">
                      <i className="bi bi-buildings"></i>
                    </div>

                    <div>
                      <strong>Bookly Limited</strong>
                      <span>Travel, Tourism & Hospitality</span>
                    </div>
                  </div>

                  <div className="contact-row">
                    <div className="contact-row-icon">
                      <i className="bi bi-envelope"></i>
                    </div>
                    <div>
                      <small>Email</small>
                      <a href="mailto:support@bookly.com.bd">
                        support@bookly.com.bd
                      </a>
                    </div>
                  </div>

                  <div className="contact-row">
                    <div className="contact-row-icon">
                      <i className="bi bi-globe2"></i>
                    </div>
                    <div>
                      <small>Website</small>
                      <a
                        href="https://www.bookly.com.bd"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.bookly.com.bd
                      </a>
                    </div>
                  </div>

                  <div className="contact-row">
                    <div className="contact-row-icon">
                      <i className="bi bi-telephone"></i>
                    </div>
                    <div>
                      <small>Phone</small>
                      <a href="tel:+8801322939333">+8801322939333</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer Tagline */}
        <section className="about-footer">
          <div className="container text-center">
            <div className="footer-icon">
              <i className="bi bi-airplane"></i>
            </div>

            <h3>Bookly Limited</h3>

            <p>
              Explore More. Stay Better. Travel Smarter.
              <span className="ms-2">✈️🏨🌍</span>
            </p>

            <div className="footer-line"></div>

            <span className="footer-caption">
              Your trusted partner for travel, tourism, and hospitality
              solutions.
            </span>
          </div>
        </section>
      </div>
    );
  }
}

export default About;
